import { userConstants } from "../constants/user.constants";

export const userActions = {
  getBasicDetails,
  getBasicDetailsSuccess,

  sendVerificationEmailRequest,
  validateVerificationEmailTokenReuqest,
  validateVerificationEmailTokenSuccess,

  changePassword,
  changePasswordSuccess,

  logout,
  logoutSuccess
};

function getBasicDetails() {
  return { type: userConstants.GET_BASIC_DETAIL_REQUEST };
}
function getBasicDetailsSuccess(payload) {
  return { type: userConstants.GET_BASIC_DETAIL_SUCCESS, payload };
}

function sendVerificationEmailRequest() {
  return { type: userConstants.SEND_VERIFICATION_EMAIL_REQUEST };
}

function validateVerificationEmailTokenReuqest(token) {
  return {
    type: userConstants.VALIDATE_VERIFICATION_EMAIL_TOKEN_REQUEST,
    payload: { token }
  };
}

function validateVerificationEmailTokenSuccess(payload) {
  return {
    type: userConstants.VALIDATE_VERIFICATION_EMAIL_TOKEN_SUCCESS,
    payload
  };
}

function changePassword(payload) {
  return { type: userConstants.CHANGE_PASSWORD, payload };
}

function changePasswordSuccess(payload) {
  return { type: userConstants.CHANGE_PASSWORD_SUCCESS, payload };
}

function logout() {
  return { type: userConstants.LOGOUT };
}

function logoutSuccess() {
  return { type: userConstants.LOGOUT_SUCCESS };
}